import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';

// Import Tailwind CSS
import './index.css';

// Import Bootstrap icons only (for existing components)
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import Supabase provider
import { SupabaseProvider } from './supabaseAuth';

const rootElement = document.getElementById('root');

const AppWrapper = (
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <SupabaseProvider>
          <App />
        </SupabaseProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// Use hydrate if the page was pre-rendered by react-snap
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, AppWrapper);
} else {
  const root = createRoot(rootElement);
  root.render(AppWrapper);
}
